import React from "react";

import {
  CheckCircle,
  BookOpen,
  ArrowRight,
} from "lucide-react";
import { useNavigate } from "react-router-dom";

export default function WealthMethodOptinSuccess() {
  const navigate = useNavigate();
  const handleCheckoutClick = () => {
    navigate("/wealth-method");
  };

  return (
    <div className="p-4 bg-gradient-to-br from-emerald-50 via-white to-green-50 flex items-center justify-center px-4">
      <div className="max-w-2xl mx-auto text-center">
        {/* Success Animation */}
        <div className="relative mb-8">
          <div className="w-16 h-16 bg-gradient-to-r from-emerald-500 to-green-500 rounded-full flex items-center justify-center mx-auto animate-pulse">
            <CheckCircle className="w-12 h-12 text-white" />
          </div>
        </div>

        {/* Success Message */}
        <div className="space-y-4 mb-8">
          <h1 className="text-3xl font-bold text-gray-900">
            Success! Check Your Email 📧
          </h1>
          <p className="text-lg text-gray-700">
            Your W.E.A.L.T.H Method Starter Kit is on its way to your inbox.
          </p>
        </div>

        {/* Email Confirmation Card */}
        <div className="bg-white rounded-2xl shadow-lg p-6 sm:p-8 mb-8">
          <h3 className="text-xl font-semibold text-gray-900 mb-2">
            What to do next:
          </h3>
          <div className="space-y-3 text-left">
            <div className="flex items-start">
              <div className="w-6 h-6 bg-emerald-100 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5 mr-3">
                <span className="text-emerald-600 font-semibold text-sm">
                  1
                </span>
              </div>
              <p className="text-gray-700">
                Check your email (including spam folder) for your free guide
              </p>
            </div>
            <div className="flex items-start">
              <div className="w-6 h-6 bg-emerald-100 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5 mr-3">
                <span className="text-emerald-600 font-semibold text-sm">
                  2
                </span>
              </div>
              <p className="text-gray-700">
                Download and read the W.E.A.L.T.H Method strategies
              </p>
            </div>
            <div className="flex items-start">
              <div className="w-6 h-6 bg-emerald-100 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5 mr-3">
                <span className="text-emerald-600 font-semibold text-sm">
                  3
                </span>
              </div>
              <p className="text-gray-700">
                Start implementing the methods within the next 48 hours
              </p>
            </div>
          </div>
        </div>

        {/* WEALTH Method Checkout Button */}
        <div className="mb-8">
          <button
            onClick={handleCheckoutClick}
            className="w-full bg-gradient-to-r from-emerald-600 to-green-600 hover:from-emerald-700 hover:to-green-700 text-white font-bold text-xl py-6 px-8 rounded-xl transition duration-300 flex items-center justify-center space-x-3 shadow-xl transform hover:scale-105"
          >
            <BookOpen className="w-6 h-6" />
            <span>Check out the W.E.A.L.T.H Method Book</span>
            <ArrowRight className="w-6 h-6" />
          </button>
          <p className="text-sm text-gray-600 mt-3">
            Transform your financial future with the complete system
          </p>
        </div>
      </div>
    </div>
  );
}
